import styled from '@emotion/styled';
import { getColor } from '../../../theme/colors/colors';

export interface StatsTileProps {
  label: string;
  value: number | string;
}

const StatsTile = ({ label, value }: StatsTileProps) => {
  return (
    <TileWrapper>
      <TileValue>{value}</TileValue>
      <TileLabel>{label}</TileLabel>
    </TileWrapper>
  );
};

export default StatsTile;

const TileWrapper = styled.div`
  min-width: 100px;
  min-height: 150px;
  background-color: #FFFFFF;
  border: 1px solid #0000001A;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  gap: 8px;
  flex: 1;
`;

const TileValue = styled.span`
  font-size: 36px;
  font-weight: 600;
  color: ${getColor('text')};
  line-height: 1;
`;

const TileLabel = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: ${getColor('text')};
  opacity: 0.7;
  text-align: center;
  line-height: 18px;
`;
